<div>
  <span *ngIf="!showProgressBar()"> {{success}} of {{total}} files uploaded<span *ngIf="failure != 0">; {{failure}} file<span *ngIf="failure > 1">s</span> failed</span></span>
  <span class="progress-span">
    <mat-progress-bar class="progress" [ngClass]="progressColor" mode="determinate" [value]="progressValue" *ngIf="showProgressBar()"></mat-progress-bar>
  </span>
  <span *ngIf="showProgressBar()" class="value-span">{{progressValue}}%</span>
</div>
